const productDetailSlider = {
    _sliderObjects: [],
    _sliderThumbsRef: [],
    _sliderGalleries: [],

    init() {
        if(document.querySelectorAll('.js-product-detail-slider').length === 0) {
            return;
        }

        let self = this;
        const scriptUrl = 'https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js';

        window.initPackage(scriptUrl).then(() => {
            self._constructSlider();
        }).catch((error) => {
            console.error(error);
        });
    }, 

    reInit() {
        let self = this;

        if(self._sliderObjects.length > 0) {
            for(const object in self._sliderObjects) {
                for(const key in self._sliderObjects[object]) {
                    if(self._sliderObjects[object][key]) {
                        self._sliderObjects[object][key].destroy();
                    }
                }
            }
            self._sliderObjects = [];
            self._sliderThumbsRef = [];
            this._sliderGalleries = [];
        }

        self.init();
    },

    _constructSlider() {
        let self = this;

        const sliders = document.querySelectorAll('.js-product-detail-slider');

        sliders.forEach((node, sliderId) => {
            let sliderGroup = new Object();
            sliderGroup.slider = new Swiper(node, {
                direction: 'horizontal',
                loop: true,
                effect: 'slide',
                
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
    
            });

            self._sliderObjects[sliderId] = sliderGroup;
            self._slideCounter(sliderGroup.slider);
            self._galleryInit(sliderGroup);
            self._setEventsNav(sliderGroup);
        });
    },

    _goToSlide(self, index, sliderGroup) {
        if(index === 3) {
            sliderGroup.gallery.openGallery(3);
        } else {
            sliderGroup.slider.slideTo(index);
        }
    },

    _galleryInit(sliderGroup) {
        let self = this;

        const scriptUrls = [
            'https://cdn.jsdelivr.net/npm/lightgallery@2.7.1/lightgallery.min.js',
            'https://cdn.jsdelivr.net/npm/lightgallery@2.7.1/plugins/zoom/lg-zoom.min.js',
            'https://cdn.jsdelivr.net/npm/lightgallery@2.7.1/plugins/thumbnail/lg-thumbnail.min.js'
          ];

        window.initPackages(scriptUrls).then(() => {
            self._galleryConstruct(sliderGroup);

        }).catch((error) => {
            console.error(error);
        });
    },

    _galleryConstruct(sliderGroup) {
        sliderGroup.gallery = lightGallery(sliderGroup.slider.el, {
            selector: sliderGroup.slider.el.querySelectorAll('a'),
            download: true,
            preload: 1,
            licenseKey: '32088F1F-749D4338-9276BA7C-4A5EF243',
            plugins: [lgZoom, lgThumbnail],
            exThumbImage: 'data-external-thumb-image', 
        });
    },

    _setEventsNav(sliderGroup) {
        let self = this;
        let sliderThumbs = sliderGroup.slider.el.parentElement.querySelectorAll('.js-product-detail-slider-nav .product-detail-slider-nav__item');

        sliderThumbs.forEach((sliderThumb, index) => {
            self._sliderThumbsRef[index] = self._goToSlide.bind(null, this, index, sliderGroup);
            sliderThumb.addEventListener('click', self._sliderThumbsRef[index], false);
        }); 
    },  

    _slideCounter(slider) {
        let self = this;
        
        let totalCountSlide =  slider.slides.length;
        if(slider.slides.length > 1) {
            let totalCountNode = slider.el.parentElement.querySelector('.js-slider-counter')
        
            totalCountNode.innerHTML = (slider.realIndex + 1) + '/' + totalCountSlide;
            
            slider.on('slideChange', function() {
                totalCountNode.innerHTML = (slider.realIndex + 1) + '/' + totalCountSlide;
            });
        }
    }
}

productDetailSlider.init();
document.addEventListener('LokiRequestEnd', function () {
    productDetailSlider.reInit();
});
